// import React from "react"
import StringBlock from "./basic/StringBlock"
import ImageBlockType from "./basic/ImageBlock"
import HeadingBlockType from "./basic/HeadingBlock"

import RecordContainerBlockType from "./data/RecordContainerBlock"
import DataRepeaterBlock from "./data/DataRepeaterBlock"

import CardBlockType from "./entity/CardBlock"

import ButtonBlockType from "./form/ButtonBlock"
import ButtonBlockType_v2 from "./form/ButtonBlock_v2"
import DateTimeBlockType from "./form/DateTimeBlock"
import FormBlockType from "./form/FormBlock"
import InputBlockType from "./form/InputBlock"
import LoginBlockType from "./form/LoginBlock"
import SelectBlockType from "./form/SelectBlock"
import CheckboxBlockType from "./form/CheckboxBlock"
import HTML2CanvasBlock from "./form/HTML2CanvasBlock"

import NavMenuBlockType from "./layout/NavMenuBlock"
import ContainerBlockType from "./layout/Container"
import ModalBlockType from "./layout/ModalBlock"

import DebugPropertyBlockType from "./other/DebugProperty"
import CustomBlockType from "./other/CustomBlock"
import RecordTableBlockType from "./data/RecordTableBlock"
import HTMLBlockType from "./other/HtmlBlock"
import MetaTagsBlockType from "./other/MetaTagsBlock"
import ImageUploadBlockType from "./form/ImageUploadBlock"
import { text } from "../attributes/items/primitives"

export const getBlockByType = (type, defaultValue) => {
    return blocksById["template_" + type] || defaultValue
}

export function getList() {
    return [
        {
            name: "Basic",
            blocks: [
                {
                    id: "template_string",
                    icon: "text",
                    label: "Text",
                    blockElement: StringBlock,
                    defaultConfig: {
                        attributes: { text: "Text here" },
                        style: {
                            default: { layout: "tight" },
                        },
                    },
                },
                {
                    id: "template_heading",
                    label: "Heading",
                    icon: "heading",
                    blockElement: HeadingBlockType,
                    defaultConfig: {
                        attributes: { text: "Heading", size: "medium" },
                        style: {
                            default: { layout: "tight" },
                        },
                    },
                },
                {
                    id: "template_image",
                    label: "Image",
                    icon: "image",
                    blockElement: ImageBlockType,
                    defaultConfig: {
                        attributes: {},
                        style: {
                            default: {
                                layout: "tight",
                                overflow: "hidden",
                                height: 500,
                                width: 500,
                            },
                        },
                    },
                },
                // { id: "template_rich-text", label: "Rich text", blockElement: RichTextBlock },
                // {
                //     id: "template_section-header",
                //     label: "Heading",
                //     blockElement: SectionHeaderBlock,
                // },
            ],
        },
        {
            name: "Advanced",
            blocks: [
                // {
                //     id: "template_debug_property",
                //     label: "DebugPropertyBlockType",
                //     blockElement: DebugPropertyBlockType,
                // },
                {
                    id: "template_html",
                    label: "Custom HTML",
                    blockElement: HTMLBlockType,
                },
                // },
                {
                    id: "template_metatags",
                    label: "Site MetaTags",
                    blockElement: MetaTagsBlockType,
                },
                {
                    id: "template_login",
                    label: "User Login Form",
                    blockElement: LoginBlockType,
                },
                // { id: "template_page-header", label: "Page Header", blockElement: PageHeaderBlock },
                // { id: "template_html", label: "Custom HTML", blockElement: HtmlBlock },
                // { id: "template_stripe", label: "Stripe", blockElement: StripeBlock },
                // { id: "template_login", label: "Login Form", blockElement: LoginBlock },
                // { id: "template_redirect", label: "Page Redirect", blockElement: RedirectBlock },
            ],
        },
        {
            name: "Data",
            blocks: [
                // { id: "template_table", label: "Record Table", blockElement: TableBlock },
                {
                    id: "template_record_data",
                    label: "Record Data",
                    icon: "record",
                    blockElement: RecordContainerBlockType,
                },
                {
                    id: "template_record_table",
                    label: "Record Table",
                    icon: "record",
                    blockElement: RecordTableBlockType,
                },

                // {
                //     id: "template_item-attributes",
                //     label: "Record Attributes",
                //     blockElement: ItemAttributesBlock,
                // },
                {
                    id: "template_repeater",
                    label: "Data Repeater",
                    blockElement: DataRepeaterBlock,
                    blockTemplate: {
                        type: "repeater",
                        config: {
                            attributes: {},
                            styles: {
                                default: {
                                    width: "100%",
                                    direction: "column",
                                    flexWrap: "nowrap",
                                    minHeight: 30,
                                },
                            },
                        },
                        childBlocks: [
                            {
                                type: "string",
                                config: {
                                    attributes: { text: "{record._primary}" },
                                    style: {
                                        default: {},
                                    },
                                },
                                childBlocks: [],
                            },
                        ],
                    },
                },
                // { id: "template_theme", label: "Theme", blockElement: ThemeBlock },
            ],
        },
        {
            name: "Layout",
            blocks: [
                {
                    id: "template_container",
                    label: "Vertical Container",
                    icon: "row",
                    blockElement: ContainerBlockType,
                    defaultConfig: {
                        style: {
                            default: { width: "100%", flexWrap: "nowrap", minHeight: 30 },
                        },
                        attributes: { direction: "column", userAdded: true },
                    },
                },
                {
                    id: "template_container",
                    label: "Horizontal container",
                    icon: "column",
                    blockElement: ContainerBlockType,
                    defaultConfig: {
                        style: {
                            default: { width: "100%", flexWrap: "nowrap", minHeight: 30 },
                        },
                        attributes: { direction: "row", userAdded: true },
                    },
                },
                {
                    id: "template_card",
                    label: "Card",
                    icon: "card",
                    blockElement: CardBlockType,
                },
                {
                    id: "template_modal",
                    label: "Popup Modal",
                    icon: "card",
                    blockElement: ModalBlockType,
                    defaultConfig: {
                        style: {
                            default: {
                                width: "60%",
                                height: "40%",
                                marginBottom: "20%",
                                backgroundColor: "#ffffff",
                                borderRadius: "4px",
                                paddingTop: 30,
                                paddingBottom: 30,
                                paddingLeft: 60,
                                paddingRight: 60,
                            },
                        },
                        attributes: { showByDefault: false, showBackdrop: true },
                    },
                },
                // {
                //     id: "template_nav_menu",
                //     label: "Nav Menu",
                //     blockElement: NavMenuBlockType,
                //     blockTemplate: {
                //         type: "nav_menu",
                //         config: { attributes: {}, styles: {} },
                //         childBlocks: NavMenuBlockType.defaultChildBlocks,
                //     },
                // },
                // {
                //     id: "template_container",
                //     label: "Container",
                //     blockElement: ContainerBlockType,
                //     defaultConfig: { theme: "default" },
                // },
                // { id: "template_section", label: "Card", blockElement: SectionBlock },
                // { id: "template_one-column", label: "One Column", blockElement: OneColumnBlock },
                // { id: "template_two-column", label: "Two Column", blockElement: TwoColumnBlock },
                // {
                //     id: "template_page",
                //     label: "Page",
                //     blockElement: PageBlock,
                //     defaultConfig: { theme: "default" },
                // },
                // { id: "template_theme", label: "Theme", blockElement: ThemeBlock },
            ],
        },
        {
            name: "Form",
            hide: true,
            blocks: [
                {
                    id: "template_input",
                    label: "Input",
                    icon: "input",
                    blockElement: InputBlockType,
                    defaultConfig: {
                        attributes: { propertyName: "inputValue" },
                    },
                },
                {
                    id: "template_button",
                    deprecated: true,
                    label: "Button",
                    icon: "button",
                    blockElement: ButtonBlockType,
                    defaultConfig: { attributes: { type: "primary", buttonTitle: "Submit" } },
                },
                {
                    id: "template_button:v2",
                    default_id: "button",
                    label: "Button",
                    icon: "button",
                    blockElement: ButtonBlockType_v2,
                    defaultConfig: { attributes: { type: "primary", buttonTitle: "Submit" } },
                },
                {
                    id: "template_form",
                    label: "Form",
                    icon: "form",
                    blockElement: FormBlockType,
                },
                {
                    id: "template_custom_block",
                    label: "Custom Block",
                    blockElement: CustomBlockType,
                },
                // { id: "template_radio", label: "Radio Button", blockElement: SelectBlock },
                // {
                //     id: "template_multi-select",
                //     label: "Multi Select",
                //     blockElement: SelectBlock,
                //     defaultConfig: { multiple: true },
                // },
                {
                    id: "template_dropdown",
                    label: "Dropdown",
                    blockElement: SelectBlockType,
                },
                {
                    id: "template_imageupload",
                    label: "Image Upload",
                    blockElement: ImageUploadBlockType,
                },
                {
                    id: "template_checkbox",
                    label: "Single Checkbox",
                    blockElement: CheckboxBlockType,
                },

                // {
                //     id: "template_datepicker",
                //     label: "Date Picker",
                //     blockElement: DateTimeBlockType,
                //     defaultConfig: { attributes: { propertyName: "primary" } }
                // }
            ],
        },
        {
            name: "Compound",
            blocks: [
                {
                    id: "template_profile_card",
                    label: "Profile Card",
                    blockElement: CardBlockType,
                    blockTemplate: {
                        type: "card",
                        config: { attributes: {}, styles: {} },
                        childBlocks: [
                            {
                                type: "container",
                                config: {
                                    attributes: {},
                                    style: {
                                        default: {
                                            backgroundColor: "#d0caca",
                                            extras: {
                                                "border-radius": "100%",
                                                "box-shadow":
                                                    "0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24)",
                                            },
                                            height: "70px",
                                            layout: "tight",
                                            margin: "-50px auto ",
                                            maxHeight: "70px",
                                            maxWidth: "70px",
                                            width: "70px",
                                        },
                                    },
                                },
                                childBlocks: [],
                                local_id: "card_0",
                                id: "card_0",
                            },
                        ],
                    },
                },
                {
                    id: "template_page_header",
                    label: "Page Header",
                    blockElement: ContainerBlockType,
                    blockTemplate: {
                        id: "page",
                        type: "container",
                        config: {
                            style: {
                                default: {
                                    width: "100%",
                                    height: "",
                                    margin: "0px auto",
                                    flexGrow: 0,
                                    justifyContent: "flex-start",
                                    backgroundColor: "#f9f9f9",
                                    minHeight: "100px",
                                },
                            },
                            broadcast: [],
                            attributes: {
                                direction: "column",
                            },
                        },
                        childBlocks: [
                            {
                                id: "card_1",
                                type: "card",
                                config: {
                                    style: {
                                        default: {
                                            height: "210px",
                                            layout: "spread",
                                            padding: "0px",
                                            boxShadow: "none",
                                        },
                                    },
                                    broadcast: [],
                                    attributes: {
                                        behavior_visibility: ["1", "eq", "2"],
                                    },
                                },
                                local_id: "card_0",
                                childBlocks: [
                                    {
                                        id: "container_1",
                                        type: "container",
                                        config: {
                                            style: {
                                                default: {
                                                    color: "#37b831",
                                                    "background-color": "#d33a4d",
                                                },
                                            },
                                            broadcast: [],
                                            attributes: {
                                                direction: "column",
                                                userAdded: true,
                                            },
                                        },
                                        local_id: "container_1",
                                        childBlocks: [],
                                    },
                                ],
                            },
                            {
                                type: "container",
                                config: {
                                    attributes: {
                                        direction: "row",
                                        userAdded: true,
                                    },
                                    style: {
                                        default: {
                                            width: "100%",
                                            flexWrap: "wrap",
                                            height: "100PX",
                                            color: "#fffff",
                                        },
                                        mobile: {
                                            height: "150px",
                                            "text-align": "center",
                                        },
                                    },
                                    broadcast: [],
                                },
                                childBlocks: [
                                    {
                                        type: "image",
                                        config: {
                                            attributes: {
                                                src:
                                                    "https://cdn.filestackcontent.com/HUak6E5wQcWAJYb8co4A",
                                                size: "contain",
                                            },
                                            style: {
                                                default: {
                                                    layout: "tight",
                                                    overflow: "hidden",
                                                    height: "100",
                                                    width: "100",
                                                },
                                            },
                                            broadcast: [],
                                        },
                                        childBlocks: [],
                                        local_id: "image_0",
                                        id: "image_0",
                                    },
                                    {
                                        type: "heading",
                                        config: {
                                            attributes: {
                                                text: "Circle",
                                                size: "medium",
                                            },
                                            style: {
                                                default: {
                                                    layout: "tight",
                                                    paddingTop: "35PX",
                                                    paddingLeft: "35PX",
                                                    paddingRight: "35PX",
                                                    paddingBottom: "35PX",
                                                },
                                                mobile: {
                                                    horizontalAlignment: "center",
                                                },
                                            },
                                            broadcast: [],
                                        },
                                        childBlocks: [],
                                        local_id: "heading_0",
                                        id: "heading_0",
                                    },
                                    {
                                        type: "container",
                                        config: {
                                            attributes: {
                                                direction: "row",
                                                userAdded: true,
                                            },
                                            style: {
                                                default: {
                                                    width: "60%",
                                                    flexWrap: "nowrap",
                                                    height: "100PX",
                                                    color: "#fffff",
                                                    horizontalAlignment: "flex-end",
                                                    minWidth: "30%",
                                                    maxWidth: "100%",
                                                    layout: "spread",
                                                },
                                                mobile: {
                                                    layout: "spread",
                                                    "text-align": "center",
                                                    horizontalAlignment: "center",
                                                },
                                            },
                                            broadcast: [],
                                        },
                                        childBlocks: [
                                            {
                                                type: "string",
                                                config: {
                                                    attributes: {
                                                        text: "Home",
                                                    },
                                                    style: {
                                                        default: {
                                                            layout: "tight",
                                                            paddingTop: "35PX",
                                                            paddingLeft: "35PX",
                                                            paddingRight: "35PX",
                                                            paddingBottom: "35PX",
                                                        },
                                                        mobile: {
                                                            paddingTop: "5px",
                                                            paddingRight: "5px",
                                                            paddingBottom: "5px",
                                                            paddingLeft: "5px",
                                                        },
                                                    },
                                                    broadcast: [],
                                                },
                                                childBlocks: [],
                                                local_id: "string_0",
                                                id: "string_0",
                                            },
                                            {
                                                type: "string",
                                                config: {
                                                    attributes: {
                                                        text: "About",
                                                    },
                                                    style: {
                                                        default: {
                                                            layout: "tight",
                                                            paddingTop: "35PX",
                                                            paddingLeft: "35PX",
                                                            paddingRight: "35PX",
                                                            paddingBottom: "35PX",
                                                        },
                                                        mobile: {
                                                            paddingTop: "5px",
                                                            paddingRight: "5px",
                                                            paddingBottom: "5px",
                                                            paddingLeft: "5px",
                                                        },
                                                    },
                                                    broadcast: [],
                                                },
                                                childBlocks: [],
                                                local_id: "string_1",
                                                id: "string_1",
                                            },
                                            {
                                                type: "string",
                                                config: {
                                                    attributes: {
                                                        text: "Team",
                                                    },
                                                    style: {
                                                        default: {
                                                            layout: "tight",
                                                            paddingTop: "35PX",
                                                            paddingLeft: "35PX",
                                                            paddingRight: "35PX",
                                                            paddingBottom: "35PX",
                                                        },
                                                        mobile: {
                                                            paddingTop: "5px",
                                                            paddingRight: "5px",
                                                            paddingBottom: "5px",
                                                            paddingLeft: "5px",
                                                        },
                                                    },
                                                    broadcast: [],
                                                },
                                                childBlocks: [],
                                                local_id: "string_2",
                                                id: "string_2",
                                            },
                                            {
                                                type: "string",
                                                config: {
                                                    attributes: {
                                                        text: "Blog",
                                                    },
                                                    style: {
                                                        default: {
                                                            layout: "tight",
                                                            paddingTop: "35PX",
                                                            paddingLeft: "35PX",
                                                            paddingRight: "35PX",
                                                            paddingBottom: "35PX",
                                                        },
                                                        mobile: {
                                                            paddingTop: "5px",
                                                            paddingRight: "5px",
                                                            paddingBottom: "5px",
                                                            paddingLeft: "5px",
                                                            horizontalAlignment: "flex-end",
                                                        },
                                                    },
                                                    broadcast: [],
                                                },
                                                childBlocks: [],
                                                local_id: "string_3",
                                                id: "string_3",
                                            },
                                        ],
                                        local_id: "container_2",
                                        id: "container_2",
                                    },
                                ],
                                local_id: "container_0",
                                id: "container_0",
                            },
                        ],
                    },
                },
                {
                    id: "template_item_card_horizontal",
                    label: "Horizontal Image Card",
                    blockElement: ContainerBlockType,
                    blockTemplate: {
                        id: "page",
                        type: "container",
                        config: {
                            style: {
                                default: {
                                    width: "500PX",
                                    height: "250PX",
                                    flexGrow: 0,
                                    justifyContent: "flex-start",
                                    backgroundColor: "#fff",
                                    flexDirection: "row",
                                },
                            },
                            broadcast: [],
                            attributes: {
                                direction: "column",
                            },
                        },
                        childBlocks: [
                            {
                                id: "image_0",
                                type: "image",
                                config: {
                                    style: {
                                        default: {
                                            width: "200",
                                            height: "100%",
                                            layout: "tight",
                                            overflow: "hidden",
                                        },
                                    },
                                    broadcast: [],
                                    attributes: {
                                        src:
                                            "https://images.unsplash.com/photo-1503088414719-16a89b27b122?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=ac67c22838204d52c929d622284ff9b0&auto=format&fit=crop&w=300&q=80",
                                        size: "cover",
                                    },
                                },
                                local_id: "image_0",
                                childBlocks: [],
                            },
                            {
                                type: "container",
                                config: {
                                    attributes: {
                                        direction: "column",
                                    },
                                    style: {
                                        default: {
                                            width: "",
                                            flexWrap: "nowrap",
                                            layout: "spread",
                                            height: "100%",
                                            paddingTop: "5%",
                                            paddingRight: "5%",
                                            paddingLeft: "5%",
                                            paddingBottom: "5%",
                                        },
                                    },
                                    broadcast: [],
                                },
                                childBlocks: [
                                    {
                                        type: "heading",
                                        config: {
                                            attributes: {
                                                text: "Your trip title",
                                                size: "medium",
                                            },
                                            style: {
                                                default: {
                                                    layout: "tight",
                                                },
                                            },
                                            broadcast: [],
                                        },
                                        childBlocks: [],
                                        local_id: "heading_0",
                                        id: "heading_0",
                                    },
                                    {
                                        type: "string",
                                        config: {
                                            attributes: {
                                                text: "Your review of this trip",
                                            },
                                            style: {
                                                default: {
                                                    layout: "tight",
                                                    width: "100%",
                                                    height: "100%",
                                                },
                                            },
                                            broadcast: [],
                                        },
                                        childBlocks: [],
                                        local_id: "string_0",
                                        id: "string_0",
                                    },
                                ],
                                local_id: "container_0",
                                id: "container_0",
                            },
                        ],
                    },
                },
            ],

            // defaultConfig: { attributes: { type: "primary" } }
        },
        {
            name: "Special",
            hide: true,
            blocks: [
                {
                    id: "template_canvas",
                    label: "Canvas Capture",
                    blockElement: HTML2CanvasBlock,
                },
            ],
        },
    ]
}

const blocksById = getList().reduce((state, { blocks }) => {
    blocks.map(block => {
        if (block.blockElement != null) {
            if (!block.blockElement.has_label) {
                block.blockElement.attributes.unshift(text({ field: "label", label: "Label" }))
                block.blockElement.has_label = true
            }
        }
        return (state[block.id] = block)
    })
    return state
}, {})



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/index.js